import { Box, LinkButton, Typography } from "@bca/ui-library";
import React from "react";
import getEnvironment from "../../getEnvironment";

interface PaymentFAQProps {
  backgroundColor?: string;
}

const PaymentFAQ: React.FunctionComponent<PaymentFAQProps> = ({
  backgroundColor,
}) => {
  const environment = getEnvironment();
  const isProd = environment === "production";
  const href = isProd
    ? "https://www.bca.co.uk/buy/paying-with-bca"
    : "https://cms.uat.britishcarauctions.net/buy/paying-with-bca";
  return (
    <Box
      marginTop="52px"
      backgroundColor={backgroundColor}
      paddingY="20px"
      paddingX={{
        mobile: "20px",
        desktop: "48px",
      }}
    >
      <Typography variant="body-small">
        For more information and help with payment methods{" "}
        <LinkButton
          href={href}
          color="text-color-hover"
          shouldOpenInNewWindow
          variant="tertiary"
          css="
            text-decoration: underline;"
          padding={0}
          height={4}
          fontWeight="bold"
          fontSize="body-small"
          data-en="click"
          data-ec="button"
          data-el="payment-faq"
          data-ea="navigate"
          data-es=""
        >
          Payment FAQs
        </LinkButton>
        .
      </Typography>
    </Box>
  );
};

export default PaymentFAQ;
